var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"theme-modal","active":_vm.active,"width":3000},on:{"update:active":function($event){_vm.active=$event}}},[_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.current}})])}
var staticRenderFns = []

export { render, staticRenderFns }